import { TipoPagamento } from '../../../../models/TipoPagamento';

import PagamentoPJPos from './PagamentoPJPos';
import PagamentoPorBoleto from './PagamentoPorBoleto';
import PagamentoPorCartao from './PagamentoPorCartao';
import PagamentoPorPix from './PagamentoPorPix';

interface Props {
  pagamentoId?: string;
  pagamentoValor?: number;
  pagamentoCpfCnpj?: string;
  tipoPagamento: TipoPagamento;
  onPaymentCompleted: () => void;
  onPaymentFailed: (reason?: string) => void;
}

export const Pagamento = ({
  pagamentoId = '',
  tipoPagamento,
  pagamentoValor,
  onPaymentCompleted,
  onPaymentFailed,
  pagamentoCpfCnpj
}: Props) => {
  switch (tipoPagamento) {
    case TipoPagamento.CartaoCredito:
    case TipoPagamento.CartaoDebito:
    case TipoPagamento.YunoCredito:
    case TipoPagamento.YunoDebito:
      return (
        <PagamentoPorCartao
          pagamentoId={pagamentoId}
          pagamentoValor={pagamentoValor}
          tipoPagamento={tipoPagamento}
          onPaymentFailed={onPaymentFailed}
          onPaymentCompleted={onPaymentCompleted}
        />
      );

    case TipoPagamento.Pix:
    case TipoPagamento.YunoPix:
      return (
        <PagamentoPorPix
          pagamentoId={pagamentoId}
          pagamentoValor={pagamentoValor}
          tipoPagamento={tipoPagamento}
          onPaymentFailed={onPaymentFailed}
          onPaymentCompleted={onPaymentCompleted}
        />
      );

    case TipoPagamento.Boleto:
      return (
        <PagamentoPorBoleto
          pagamentoValor={pagamentoValor}
          onPaymentFailed={onPaymentFailed}
          pagamentoCpfCnpj={pagamentoCpfCnpj}
          pagamentoId={pagamentoId}
        />
      );

    case TipoPagamento.PJPosPago:
      return (
        <PagamentoPJPos onPaymentFailed={onPaymentFailed} onPaymentCompleted={onPaymentCompleted} />
      );

    default:
      return <></>;
  }
};
